import React, { Component } from "react";
import { BarChart } from "ui-kit-ck-consultant";

import { getPercentageValue } from "../../../utils/general";

export class LineChartRPRate extends Component {

  render() {
    return (
      <BarChart
        height={this.props.height}
        title={"Taux de RP"}
        format="percentage"
        legendDisplay={false}
        dataSet={[
          {
            data: this.props.data.RP_RATE,
            type: "line",
            color: "#6067AE",
          },
        ]}
        yAxes={[
          {
            display: false,
            dataLabelsOptions: { display: true },
            ticks: {
              max: 100,
              min: 0,
              beginAtZero: true,
            },
          },
        ]}
        datalabels2={[
          {
            display: true,
            align: "bottom",
            anchor: "end",
            clamp: true,
            color: "#0162AD",
            font: {
              size: "8",
            },
            formatter: (value) => getPercentageValue(value),
          },
        ]}
      />
    );
  }
}

export default LineChartRPRate;
